import { render, staticRenderFns } from "./FarmResultSummary.vue?vue&type=template&id=0d6ffe0f&scoped=true&"
import script from "./FarmResultSummary.vue?vue&type=script&lang=ts&"
export * from "./FarmResultSummary.vue?vue&type=script&lang=ts&"
import style0 from "./FarmResultSummary.vue?vue&type=style&index=0&id=0d6ffe0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6ffe0f",
  null
  
)

export default component.exports